// @ts-expect-error
const localeData = window.localeData;

/**
 * Formats a number with fixed precision of 2, given the desired currency and
 * locale language of the user.
 * @param  {number} value             - Number to format
 * @param  {currency} currency        - ISO 4217 currency code
 * @return {string}                   - Formatted number as a string
 */
export function formatCurrencyValue(value: number, currency: string): string {
    // Best way to get ensure number precision without turning it
    // into a string
    //
    // refs: https://stackoverflow.com/a/29494612
    const formattedNumber = Math.round(value * 1e2) / 1e2;

    // The localeDate.language comes directly from Zend, and lives
    // on the `window`
    return formattedNumber.toLocaleString(localeData.language, {
        style: 'currency',
        currency: currency,
    });
}
